/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AppSagasLoadDataQueryVariables = {};
export type AppSagasLoadDataQueryResponse = {
    readonly parameterList: {
        readonly parameters: ReadonlyArray<{
            readonly parameterId: string;
            readonly parameter: string;
            readonly description: string | null;
            readonly value: string | null;
        } | null> | null;
    } | null;
    readonly categoryList: {
        readonly categories: ReadonlyArray<{
            readonly categoryId: string;
            readonly sort: number | null;
            readonly enabledVehicleGroups: ReadonlyArray<{
                readonly vehicleGroupId: string;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly regionList: {
        readonly regions: ReadonlyArray<{
            readonly region: string | null;
            readonly enabledStations: ReadonlyArray<{
                readonly stationId: string | null;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly vehicleGroupList: {
        readonly vehicleGroups: ReadonlyArray<{
            readonly vehicleGroupId: string;
            readonly category: string | null;
            readonly categoryText: string | null;
            readonly description: string | null;
            readonly descriptionWeb: string | null;
            readonly isEnabledForInternetUsage: boolean | null;
            readonly sort: number | null;
            readonly textWeb: string | null;
        } | null> | null;
    } | null;
    readonly stationList: {
        readonly stations: ReadonlyArray<{
            readonly stationId: string | null;
            readonly city: string | null;
            readonly country: {
                readonly countryId: string;
                readonly name: string | null;
                readonly sign: string | null;
            } | null;
            readonly disponame: string | null;
            readonly email: string | null;
            readonly fax: string | null;
            readonly isForeignStation: boolean | null;
            readonly isOneWayStation: boolean | null;
            readonly isRentStation: boolean | null;
            readonly isSharingStation: boolean | null;
            readonly latitude: number | null;
            readonly longitude: number | null;
            readonly name: string | null;
            readonly openingdate: string | null;
            readonly opentime: ReadonlyArray<{
                readonly breakEndtime: string | null;
                readonly breakStarttime: string | null;
                readonly endtime: string | null;
                readonly opentimeId: string;
                readonly starttime: string | null;
                readonly station: string | null;
                readonly weekDay: string | null;
            } | null> | null;
            readonly phonenumber: string | null;
            readonly street: string | null;
            readonly zipcode: string | null;
            readonly autoGenerateVehicleId: boolean | null;
        } | null> | null;
    } | null;
    readonly mandant: {
        readonly mandantId: string;
        readonly logo: string | null;
        readonly abasId: number;
        readonly jasperHeader: string | null;
        readonly jasperFooter: string | null;
        readonly ownercode: string | null;
        readonly modules: ReadonlyArray<{
            readonly enabled: boolean;
            readonly name: string;
        } | null> | null;
        readonly openRemarkPopupInContract: boolean | null;
    } | null;
};
export type AppSagasLoadDataQuery = {
    readonly response: AppSagasLoadDataQueryResponse;
    readonly variables: AppSagasLoadDataQueryVariables;
};



/*
query AppSagasLoadDataQuery {
  parameterList {
    parameters {
      parameterId
      parameter
      description
      value
    }
  }
  categoryList {
    categories {
      categoryId
      sort
      enabledVehicleGroups {
        vehicleGroupId
      }
    }
  }
  regionList {
    regions {
      region
      enabledStations {
        stationId
      }
    }
  }
  vehicleGroupList {
    vehicleGroups {
      vehicleGroupId
      category
      categoryText
      description
      descriptionWeb
      isEnabledForInternetUsage
      sort
      textWeb
    }
  }
  stationList {
    stations {
      stationId
      city
      country {
        countryId
        name
        sign
      }
      disponame
      email
      fax
      isForeignStation
      isOneWayStation
      isRentStation
      isSharingStation
      latitude
      longitude
      name
      openingdate
      opentime {
        breakEndtime
        breakStarttime
        endtime
        opentimeId
        starttime
        station
        weekDay
      }
      phonenumber
      street
      zipcode
      autoGenerateVehicleId
    }
  }
  mandant {
    mandantId
    logo
    abasId
    jasperHeader
    jasperFooter
    ownercode
    modules {
      enabled
      name
    }
    openRemarkPopupInContract
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sort",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vehicleGroupId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ParameterList",
    "kind": "LinkedField",
    "name": "parameterList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Parameter",
        "kind": "LinkedField",
        "name": "parameters",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parameterId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parameter",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CategoryList",
    "kind": "LinkedField",
    "name": "categoryList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "categories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryId",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VehicleGroup",
            "kind": "LinkedField",
            "name": "enabledVehicleGroups",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RegionList",
    "kind": "LinkedField",
    "name": "regionList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "regions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "region",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Station",
            "kind": "LinkedField",
            "name": "enabledStations",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "VehicleGroupList",
    "kind": "LinkedField",
    "name": "vehicleGroupList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VehicleGroup",
        "kind": "LinkedField",
        "name": "vehicleGroups",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryText",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionWeb",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabledForInternetUsage",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textWeb",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "StationList",
    "kind": "LinkedField",
    "name": "stationList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Station",
        "kind": "LinkedField",
        "name": "stations",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryId",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sign",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disponame",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fax",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isForeignStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOneWayStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRentStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSharingStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longitude",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openingdate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Opentime",
            "kind": "LinkedField",
            "name": "opentime",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "breakEndtime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "breakStarttime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endtime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "opentimeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "starttime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "station",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekDay",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phonenumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "zipcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoGenerateVehicleId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Mandant",
    "kind": "LinkedField",
    "name": "mandant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mandantId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "abasId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jasperHeader",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jasperFooter",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ownercode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Module",
        "kind": "LinkedField",
        "name": "modules",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "openRemarkPopupInContract",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppSagasLoadDataQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppSagasLoadDataQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "cb62cc9e04cca17956e6326c77407e77",
    "id": null,
    "metadata": {},
    "name": "AppSagasLoadDataQuery",
    "operationKind": "query",
    "text": "query AppSagasLoadDataQuery {\n  parameterList {\n    parameters {\n      parameterId\n      parameter\n      description\n      value\n    }\n  }\n  categoryList {\n    categories {\n      categoryId\n      sort\n      enabledVehicleGroups {\n        vehicleGroupId\n      }\n    }\n  }\n  regionList {\n    regions {\n      region\n      enabledStations {\n        stationId\n      }\n    }\n  }\n  vehicleGroupList {\n    vehicleGroups {\n      vehicleGroupId\n      category\n      categoryText\n      description\n      descriptionWeb\n      isEnabledForInternetUsage\n      sort\n      textWeb\n    }\n  }\n  stationList {\n    stations {\n      stationId\n      city\n      country {\n        countryId\n        name\n        sign\n      }\n      disponame\n      email\n      fax\n      isForeignStation\n      isOneWayStation\n      isRentStation\n      isSharingStation\n      latitude\n      longitude\n      name\n      openingdate\n      opentime {\n        breakEndtime\n        breakStarttime\n        endtime\n        opentimeId\n        starttime\n        station\n        weekDay\n      }\n      phonenumber\n      street\n      zipcode\n      autoGenerateVehicleId\n    }\n  }\n  mandant {\n    mandantId\n    logo\n    abasId\n    jasperHeader\n    jasperFooter\n    ownercode\n    modules {\n      enabled\n      name\n    }\n    openRemarkPopupInContract\n  }\n}\n"
  }
};
})();
(node as any).hash = '54615f79952165ce03e3d30c68a7ef49';
export default node;
